/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cart_Empty_SubInputs */

const en_cart_empty_sub = /** @type {(inputs: Cart_Empty_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once you add seeds they will show up here.`)
};

const th_cart_empty_sub = /** @type {(inputs: Cart_Empty_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมื่อคุณเพิ่มเมล็ดพันธุ์ รายการจะแสดงที่นี่`)
};

const ja_cart_empty_sub = /** @type {(inputs: Cart_Empty_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シードを追加するとここに表示されます。`)
};

const fr_cart_empty_sub = /** @type {(inputs: Cart_Empty_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les graines ajoutées apparaîtront ici.`)
};

const es_cart_empty_sub = /** @type {(inputs: Cart_Empty_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las semillas que añadas aparecerán aquí.`)
};

const ru_cart_empty_sub = /** @type {(inputs: Cart_Empty_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавленные семена появятся здесь.`)
};

const zh_cart_empty_sub = /** @type {(inputs: Cart_Empty_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入种子后会显示在这里。`)
};

const vi_cart_empty_sub = /** @type {(inputs: Cart_Empty_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khi bạn thêm hạt giống, chúng sẽ hiện ở đây.`)
};

/**
* | output |
* | --- |
* | "Once you add seeds they will show up here." |
*
* @param {Cart_Empty_SubInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const cart_empty_sub = /** @type {((inputs?: Cart_Empty_SubInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cart_Empty_SubInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_cart_empty_sub(inputs)
	if (locale === "ja") return ja_cart_empty_sub(inputs)
	if (locale === "fr") return fr_cart_empty_sub(inputs)
	if (locale === "es") return es_cart_empty_sub(inputs)
	if (locale === "ru") return ru_cart_empty_sub(inputs)
	if (locale === "zh") return zh_cart_empty_sub(inputs)
	if (locale === "vi") return vi_cart_empty_sub(inputs)
	return en_cart_empty_sub(inputs)
});